import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Lisa ostukorvi

  <span style="color:#85c1dc;">**FI:**</span>
  Lisää ostoskoriin

  <span style="color:#85c1dc;">**RU:**</span>
  Добавить в корзину
*/
/* @__NO_SIDE_EFFECTS__ */
const m62 = msg(
  mf`Lisa ostukorvi`,
  mf`Lisää ostoskoriin`,
  mf`Добавить в корзину`,
)

export { m62 as 'w.wishlist.add_item_to_cart' }